import { clientPortalApi } from '@/lib/api/client-portal.api'
import { organizationInvitesApi } from '@/lib/api/organization-invites.api'

export type InviteType = 'organization' | 'client-portal'

export const CLIENT_PORTAL_INVITE_TYPE: InviteType = 'client-portal'

export function parseInviteType(value: string | null | undefined): InviteType {
  return value === CLIENT_PORTAL_INVITE_TYPE
    ? CLIENT_PORTAL_INVITE_TYPE
    : 'organization'
}

export async function acceptInviteForType(
  token: string,
  type: InviteType,
): Promise<void> {
  if (type === CLIENT_PORTAL_INVITE_TYPE) {
    await clientPortalApi.acceptInvite({ token })
    return
  }

  await organizationInvitesApi.acceptInvite(token)
}
